import React from 'react';
import { connect } from 'react-redux';

function ZeneraFooter(props) {

  var phoneResult = props.user_phone.substr(0, 3) + " " + props.user_phone.substr(3, 3) + " " + props.user_phone.substr(6, 3);
  return (
    <>
      <div id="divtocopy">
        <table cellPadding="0" width="590" cellSpacing="0" style={{ verticalAlign: "-webkit-baseline-middle", fontSize: "medium", fontFamily: "Arial", color: "#fff", backgroundColor: "#080F20", backgroundImage: "url(https://columbusenergy.pl/lp/stopka/generator/assets/zenera-bg.png)", backgroundSize: "100% 100%", backgroundPosition: "center", backgroundRepeat: "no-repeat", padding: "25px", borderRadius: "16px" }}>
          <tbody>
            {/* <tr className="gmail-fix">
                <td>
                  <table cellPadding="0" cellSpacing="0" border="0" align="center" width="500">
                    <tr>
                      <td cellPadding="0" cellSpacing="0" border="0" height="1">
                        <img src="https://columbusenergy.pl/lp/stopka/spacer.jpg" width="500" height="1" style={{display:"block",maxHeight:"1px",minHeight:"1px",minWidth:"500px",width:"500px"}} alt=""/>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr> */}
            <tr>
              <td>
                <table width="100%">
                  <tbody>
                    <tr>
                      <td style={{ color: "rgb(255, 255, 255)", padding: "0", verticalAlign: "top" }}>
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <h1 style={{ fontFamily: "Arial", margin: "0", fontWeight: "400", fontSize: "28px", color: "rgb(255, 255, 255)" }}>
                                  {props.user_name}
                                  <span style={{ fontSize: "28px", fontFamily: "Arial", fontWeight: "400", color: "rgb(255, 255, 255)" }}>
                                    &nbsp;{props.user_surname}
                                  </span>
                                </h1>
                                <h4 style={{ fontFamily: "Arial", fontWeight: "normal", margin: "0", fontSize: "14px", color: "#7DFFB6" }}>
                                  {props.user_position}
                                </h4>
                              </td>
                            </tr>
                            <tr>
                              <td height="25"></td>
                            </tr>
                            <tr>
                              <td width="350">
                                <table>
                                  <tbody>
                                    <tr>
                                      <td style={{ paddingBottom: "5px" }}>
                                        {!props.user_phone ? (
                                          <span></span>
                                        ) : (
                                          <>
                                            <img style={{ verticalAlign: "bottom", width: "18px" }} src="https://columbusenergy.pl/lp/stopka/generator/assets/zenera-phone.png" alt="" />
                                            &nbsp;<span style={{ fontFamily: "Arial", lineHeight: "18px", fontWeight: "400", fontSize: "14px", display: "inline-block", paddingLeft: "10px", color: "rgb(255, 255, 255)" }}>
                                              +48 {phoneResult}
                                            </span>
                                          </>
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <img style={{ verticalAlign: "middle", width: "18px" }} src="https://columbusenergy.pl/lp/stopka/generator/assets/zenera-mail.png" alt="" />
                                        &nbsp;<span style={{ fontFamily: "Arial", margin: "0", lineHeight: "26px", fontWeight: "400", fontSize: "14px", display: "inline-block", paddingLeft: "10px", color: "rgb(255, 255, 255)" }}>
                                          {props.user_email}
                                        </span>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td style={{ width: "180px", textAlign: "left", verticalAlign: "top" }}>
                        <table cellPadding="0" width="180">
                          <tbody>
                            <tr>
                              <td width="270">
                                <img src="https://columbusenergy.pl/lp/stopka/generator/assets/zenera-logo.png" alt="Zenera" width="270" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr style={{ height: "25px", verticalAlign: "middle" }}>
              <td>
                <hr size="1" color="#7DFFB6"></hr>
              </td>
            </tr>
            <tr>
              <td>
                <table width="590">
                  <tbody>
                    <tr>
                      <td width="220" >
                        <table style={{ borderSpacing: "0" }}>
                          <tbody>
                            <tr>
                              <td>
                                <img src="https://columbusenergy.pl/lp/stopka/generator/assets/zenera-sign.png" alt="" style={{ verticalAlign: "middle", width: "40px", height: "auto" }} />
                              </td>
                              <td style={{ lineHeight: "13px", fontSize: "10px", fontFamily: "Arial", color: "rgb(255, 255, 255)", fontWeight: "400", padding: "0 20px 0 20px" }}>
                                <span style={{ color: "#fff", fontSize: "10px", fontWeight: "700" }}>
                                  Zenera Sp. z o.o.
                                </span><br />
                                <span style={{ color: "#fff", fontSize: "10px", fontWeight: "400" }}>
                                  ul. Pana Tadeusza 4
                                  <br />30-727 Kraków
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td width="240">
                        <table style={{ borderSpacing: "0" }}>
                          <tbody>
                            <tr>
                              <td style={{ lineHeight: "13px", fontSize: "10px", fontFamily: "Arial", color: "rgb(255, 255, 255)", fontWeight: "400", padding: "0" }}>
                                NIP:  851-320-78-16<br />
                                kontakt@zenera.energy<br />
                                tel. +48 22 123 04 44
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td width='130'>
                        <table width='130' style={{ borderSpacing: "0" }}>
                          <tbody>
                            <tr>
                              <td width='30' align="right" style={{ textAlign: "right" }}>
                                <a style={{ display: "inline-block", textDecoration: "none" }} href="https://www.facebook.com/profile.php?id=61582481065444">
                                  <img width='30' src="https://columbusenergy.pl/lp/stopka/generator/assets/zenera-fb.png" alt="" />
                                </a>
                              </td>
                              <td width='30' align="right" style={{ textAlign: "right" }}>
                                <a style={{ textDecoration: "none" }} href="https://www.instagram.com/zenera.energy/">
                                  <img width='30' src="https://columbusenergy.pl/lp/stopka/generator/assets/zenera-inst.png" alt="" />
                                </a>
                              </td>
                              <td width='30' align="right" style={{ textAlign: "right" }}>
                                <a style={{ display: "inline-block", textDecoration: "none" }} href="https://www.linkedin.com/company/zeneraai/">
                                  <img width='30' src="https://columbusenergy.pl/lp/stopka/generator/assets/zenera-in.png" alt="" />
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
function mapStateToProps(state) {
  return {
    user_name: state.user_reducer.user_name,
    user_surname: state.user_reducer.user_surname,
    user_position: state.user_reducer.user_position,
    user_email: state.user_reducer.user_email,
    user_phone: state.user_reducer.user_phone,
  }
}
export default connect(mapStateToProps)(ZeneraFooter);